<template>
  <div class="app-wrapper">
    <header class="top-header">
      <div class="header-brand">
        <div class="brand-mark">T</div>
        <div class="brand-info">
          <span class="brand-name">thxily</span>
          <span class="brand-sub">管理コンソール</span>
        </div>
      </div>
      <button class="back-btn" v-on:click="back">← メニューへ戻る</button>
    </header>
    <main class="main-content">
      <div class="white-card">
        <div class="page-head">
          <div>
            <p class="page-kicker">Admin content</p>
            <h1 class="page-title">管理者投稿</h1>
            <p class="page-copy">
              投稿者、本文、添付画像を一つの流れで入力できるように整理しています。
              画像付き投稿でも本文とのバランスが見やすいレイアウトです。
            </p>
          </div>
          <div class="page-badge">
            <span class="page-badge__label">Mode</span>
            <span class="page-badge__value">Admin post</span>
          </div>
        </div>

        <form id="form" v-on:submit.prevent="dummy">
          <div class="editor-grid">
            <section class="primary-panel">
              <div class="section-card">
                <div class="section-head">
                  <div>
                    <p class="section-kicker">Post</p>
                    <h2 class="section-title">投稿内容</h2>
                  </div>
                </div>

                <div class="field-grid">
                  <div class="form-group">
                    <label class="form-label">投稿者</label>
                    <select id="userSelect" v-model="user_id" class="form-control">
                      <option v-for="user in users" :key="user.id" :value="user.id">{{ user.name }}</option>
                    </select>
                  </div>

                  <div class="form-group">
                    <label class="form-label">投稿内容</label>
                    <textarea v-model="comment" class="form-control form-control--textarea" required></textarea>
                  </div>
                </div>
              </div>
            </section>

            <section class="detail-panel">
              <div class="section-card">
                <div class="section-head">
                  <div>
                    <p class="section-kicker">Visual</p>
                    <h2 class="section-title">添付画像</h2>
                  </div>
                </div>

                <div class="image-preview">
                  <img :src="card.image" class="preview-img" />
                </div>

                <div class="form-group">
                  <label class="form-label">画像ファイル</label>
                  <input type="file" class="form-control form-control--file" v-on:change="fileSelected" />
                </div>
              </div>

              <div class="section-card">
                <div class="section-head">
                  <div>
                    <p class="section-kicker">Checklist</p>
                    <h2 class="section-title">投稿前の確認</h2>
                  </div>
                </div>

                <ul class="summary-list">
                  <li>投稿者は `nonusers` の一覧から選択されます。</li>
                  <li>画像は投稿時に一緒に保存されます。</li>
                  <li>本文だけでも投稿できますが、視認性を上げたいなら画像を付けるのが有効です。</li>
                </ul>
              </div>
            </section>
          </div>

          <div class="button-row">
            <button v-on:click="create" class="btn-primary">作成</button>
            <button v-on:click="back" class="btn-secondary">戻る</button>
          </div>
        </form>
      </div>
    </main>
  </div>
</template>

<script>
import axios from "axios";
import router from "@/router";
import { useRoute } from 'vue-router';
import store from "@/store";

const DUMMY_IMG = "data:image/png;base64,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"

export default {
  data: function () {
    return {
      card: {
        image: '',
      },
      comment: '',
      is_default: false,
      fileInfo: '',
      user_id: '',
      users: [],
    }
  },
  async mounted() {
    const route = useRoute()
    this.fetchUsers();
  },
  methods: {
    dummy: function () {
    },
    create: function () {
      let nodes = document.querySelectorAll(`#form :invalid`)
      if (nodes.length > 0) {
        return
      }
      const data = {
        id: null,
        comment: this.comment,
        is_default: this.is_default,
        image: this.card.image,
        user_id: this.user_id.toString()
      };
      axios.post("/post_thx_info", data).then((res) => {
        router.push("/menu")
      })
    },
    fileSelected: function (event) {
      this.fileInfo = event.target.files[0];
      store.dispatch("resizeImage", { 'imageData': this.fileInfo, 'width': 2048, 'height': 1024 }).then((image) => {
        this.card.image = image;
      })
    },
    fetchUsers: function () {
      axios.get("/nonusers").then((response) => {
        this.users = response.data
      });
    },
    back: function () {
      router.push("/menu")
    },
    logout: function () {
      store.dispatch("logout")
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700&display=swap');

.app-wrapper {
  min-height: 100vh;
  background: #DDE2EC;
  font-family: 'Noto Sans JP', 'Segoe UI', sans-serif;
}

.top-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  height: 64px;
  background: #1E2A3A;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
}

.header-brand { display: flex; align-items: center; gap: 12px; }

.brand-mark {
  width: 38px; height: 38px; border-radius: 10px;
  background: linear-gradient(135deg, #4F8EF7, #7C5CFC);
  display: flex; align-items: center; justify-content: center;
  font-size: 1.1rem; font-weight: 800; color: #fff;
}

.brand-info { display: flex; flex-direction: column; line-height: 1.2; }
.brand-name { font-size: 1rem; font-weight: 700; color: #fff; }
.brand-sub  { font-size: 0.68rem; color: #8A9BB0; }

.back-btn {
  padding: 8px 20px; border-radius: 8px;
  border: 1.5px solid #94A3B8; background: transparent;
  color: #94A3B8; font-size: 0.85rem; font-weight: 600;
  cursor: pointer; font-family: inherit;
  transition: background 0.2s, color 0.2s;
}
.back-btn:hover { background: #94A3B8; color: #1E2A3A; }

.main-content {
  max-width: 1180px; margin: 0 auto;
  padding: 40px 24px 80px;
}

.white-card {
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 12px 30px rgba(15,23,42,0.08);
  padding: 32px 40px;
}

.page-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 28px;
  padding-bottom: 20px;
  border-bottom: 1px solid #E2E8F0;
}

.page-kicker {
  margin: 0 0 8px;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #64748B;
}

.page-title {
  font-size: 1.55rem;
  font-weight: 700;
  color: #1E293B;
  margin: 0;
}

.page-copy {
  max-width: 58ch;
  margin: 12px 0 0;
  color: #64748B;
  font-size: 0.95rem;
  line-height: 1.8;
}

.page-badge {
  display: inline-flex;
  flex-direction: column;
  gap: 6px;
  min-width: 120px;
  padding: 12px 14px;
  border-radius: 14px;
  background: #F8FAFC;
  border: 1px solid #E2E8F0;
}

.page-badge__label {
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748B;
}

.page-badge__value {
  font-size: 1rem;
  font-weight: 700;
  color: #0F172A;
}

.editor-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(320px, 0.9fr);
  gap: 24px;
  align-items: start;
}

.primary-panel,
.detail-panel {
  display: grid;
  gap: 20px;
}

.section-card {
  padding: 20px;
  border-radius: 18px;
  background: linear-gradient(180deg, #FFFFFF 0%, #F8FAFC 100%);
  border: 1px solid #E2E8F0;
}

.section-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}

.section-kicker {
  margin: 0 0 6px;
  font-size: 0.74rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #64748B;
}

.section-title {
  margin: 0;
  font-size: 1.08rem;
  font-weight: 700;
  color: #1E293B;
}

.field-grid {
  display: grid;
  gap: 16px;
}

.form-group { margin-bottom: 0; }
.form-label { display: block; font-size: 0.85rem; font-weight: 600; color: #475569; margin-bottom: 6px; }

.form-control {
  width: 100%;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1.5px solid #CBD5E1;
  font-size: 0.9rem;
  font-family: inherit;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.form-control:focus {
  border-color: #3B82F6;
  box-shadow: 0 0 0 4px rgba(59,130,246,0.12);
}

.form-control--textarea {
  min-height: 220px;
  resize: vertical;
}

.form-control--file {
  background: #F8FAFC;
}

.image-preview {
  margin-bottom: 16px;
}

.preview-img {
  width: 100%;
  min-height: 240px;
  max-height: 360px;
  object-fit: contain;
  border-radius: 14px;
  border: 1.5px solid #E2E8F0;
  display: block;
  background: #FFF;
}

.summary-list {
  margin: 0;
  padding-left: 20px;
  color: #475569;
  line-height: 1.8;
  text-align: left;
}

.button-row {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 28px;
  padding-top: 20px;
  border-top: 1px solid #E2E8F0;
}

.btn-primary {
  padding: 10px 24px; border-radius: 12px; border: none;
  background: #3B82F6; color: #fff;
  font-size: 0.9rem; font-weight: 600; cursor: pointer;
  font-family: inherit; transition: background 0.2s, transform 0.2s;
}
.btn-primary:hover { background: #2563EB; transform: translateY(-1px); }

.btn-secondary {
  padding: 10px 24px; border-radius: 12px;
  border: 1.5px solid #CBD5E1; background: #fff;
  color: #475569; font-size: 0.9rem; font-weight: 600;
  cursor: pointer; font-family: inherit; transition: background 0.2s, transform 0.2s;
}
.btn-secondary:hover { background: #F1F5F9; transform: translateY(-1px); }

@media (max-width: 900px) {
  .page-head,
  .editor-grid {
    grid-template-columns: 1fr;
    flex-direction: column;
  }

  .page-badge {
    width: 100%;
  }
}

@media (max-width: 640px) {
  .top-header {
    padding: 0 16px;
  }

  .main-content {
    padding: 24px 14px 60px;
  }

  .white-card {
    padding: 22px 18px;
  }

  .section-card {
    padding: 16px;
  }

  .button-row {
    flex-direction: column;
  }

  .button-row > * {
    width: 100%;
  }
}
</style>
